module.exports = __webpack_public_path__ + "img/pink-mask.ff1ba9ac.svg";